import { useEffect, useRef } from 'react';
import lottie, { RendererType, AnimationItem } from 'lottie-web';

type AnimationProps = {
  renderer?: RendererType;
  loop?: boolean;
  autoplay?: boolean;
  animationData: string;
  visible: boolean;
  scaleSettings?: object;
  className: string;
};

const Animation = ({
  renderer = 'svg',
  loop = true,
  autoplay = true,
  animationData,
  visible,
  scaleSettings,
  className,
}: AnimationProps) => {
  const animationContainerRef = useRef<HTMLDivElement>(null);
  const animationInstanceRef = useRef<AnimationItem | null>(null);

  useEffect(() => {
    let parsedAnimationData: string = '';
    parsedAnimationData = JSON.parse(animationData);

    if (!!Object.keys(parsedAnimationData).length && animationContainerRef.current) {
      animationInstanceRef.current = lottie.loadAnimation({
        container: animationContainerRef.current,
        renderer,
        loop,
        autoplay,
        animationData: parsedAnimationData,
        rendererSettings: scaleSettings,
      });
    }

    if (animationInstanceRef.current) {
      if (visible) {
        animationInstanceRef.current.play();
      } else {
        animationInstanceRef.current.stop();
      }
    }

    return () => {
      animationInstanceRef.current?.destroy();
      animationInstanceRef.current = null;
    };
  }, [animationData, autoplay, loop, renderer, scaleSettings, visible]);

  return <div ref={animationContainerRef} className={className} />;
};

export default Animation;
